/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { PieChartSeriesOptions } from 'highcharts';
import datasetTypes from '../../enums/datasetTypes';
import genericChartVisualizationStaticPropertiesReducer from './chart/reducers/genericChartVisualizationReducer';
import { PieVisualization } from './PieVisualization';

export class SemiPieVisualization extends PieVisualization {

    getChartSection() {
        const chart = super.getChartSection();

        return {
            ...chart,
            type: 'SemiPie'
        };
    }

    getPlotOptionsSection() {
        const section = super.getPlotOptionsSection();
        return {
            ...section,
            pie: {
                ...section.pie,
                startAngle: -90,
                endAngle: 90,
            }
        };
    }

    getSeriesSection(selectedColIndex: number, selectedRowIndex: number): PieChartSeriesOptions[] {

        const section = super.getSeriesSection(selectedColIndex, selectedRowIndex);

        for (let i = 0; i < section.length; i += 1) {
            const size = parseFloat((section[i].size as string));

            if (section && section[i] && section[i].center) {
                const { center } = section[i];
                if (center && center[1]) {
                    let centerY = parseFloat((center[1] as string));
                    centerY += ((centerY * size) / 100) / 2;
                    center[1] = `${centerY}%`;
                }
            }
        }

        return section;
    }
}

export const SemiPieVisualizationDescriptor = {
    legacyAdhoc: 'semi_pie',
    parentClass: 'Pie',
    cssClass: 'SemiPie',
    bundleName: 'adhoc.visualisation.chooser.type.SEMI_PIE',
    name: 'SemiPie',
    group: 'adhoc.visualisation.chooser.type.GROUP_PIE',
    datasetType: datasetTypes.MULTI_AXIS,
    component: SemiPieVisualization,
    staticPropertiesReducer: genericChartVisualizationStaticPropertiesReducer,
    requirements: {
        measures: { min: 1 },
        fields: { min: 0 }
    }
};
